import React from "react";
import "../../../../../css/pages/ca_pages/teams/teams_model/DashboardRecentActivity.css";

const getActivityConfig = (action) => {
    switch (action) {
        case "completed":
            return { icon: "✅", color: "#16a34a" };

        case "assigned":
        case "reassigned":
            return { icon: "📋", color: "#2563eb" };

        case "paused":
            return { icon: "⏸", color: "#ea580c" };

        case "created":
            return { icon: "➕", color: "#7c3aed" };

        case "started":
        case "resumed":
            return { icon: "▶️", color: "#16a34a" };

        case "cancelled":
            return { icon: "❌", color: "#dc2626" };

        default:
            return { icon: "📌", color: "#64748b" };
    }
};

const formatAction = (action) => {
    if (!action) {return "Activity";}

    return action
        .replaceAll("_", " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());
};

const formatTime = (date) => {
    if (!date) {return "--";}

    const value = new Date(date);

    if (Number.isNaN(value.getTime())) {return "--";}

    return value.toLocaleString([], {
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
    });
};

const DashboardRecentActivity = ({ activities = [] }) => {
    return (
        <div className="activity-card">
            <div className="activity-header">
                <div>
                    <h2>Recent Activity</h2>
                    <p>Latest activity across your team.</p>
                </div>

                <button>
                    View Timeline
                </button>
            </div>

            <div className="activity-list">
                {activities.length === 0 ? (
                    <div
                        style={{
                            padding: "20px",
                            textAlign: "center",
                            color: "#64748b",
                        }}
                    >
                        No recent activity.
                    </div>
                ) : (
                    activities.map((activity, index) => {
                        const config = getActivityConfig(activity.action);

                        return (
                            <div
                                key={`${activity.task}-${activity.created_at}-${index}`}
                                className="activity-item"
                            >
                                <div
                                    className="activity-icon"
                                    style={{
                                        background: `${config.color}15`,
                                        color: config.color,
                                    }}
                                >
                                    {config.icon}
                                </div>

                                <div className="activity-content">
                                    <div className="activity-title">
                                        {formatAction(activity.action)}
                                    </div>

                                    <div className="activity-description">
                                        {activity.task}

                                        {activity.employee
                                            ? ` — ${activity.employee}`
                                            : ""}
                                    </div>
                                </div>

                                <div className="activity-time">
                                    {formatTime(activity.created_at)}
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
};

export default DashboardRecentActivity;
